import { useState, type FC, useEffect } from 'react'
import clsx from 'clsx'

import { FilterStatusPengiriman } from 'app/KinerjaShared/components/FilterSearchStatusPengiriman/FilterStatusPengiriman'
import { SearchStatusPengiriman } from 'app/KinerjaShared/components/FilterSearchStatusPengiriman/SearchStatusPengiriman'

import type { FilterItem } from 'app/KinerjaShared/components/FilterSearchStatusPengiriman/FilterStatusPengiriman'
import type { TPenilaianMeta } from 'types/kinerja-ps'

type FilterSearchStatusPengirimanProps = {
  isLoading?: boolean
  data?: TPenilaianMeta['counts']
  onChange: (params: { filter: FilterItem[]; search: string }) => void
  className?: string
  hideSearch?: boolean
  hideBelumDinilai?: boolean
}

export const FilterSearchStatusPengiriman: FC<
  FilterSearchStatusPengirimanProps
> = ({
  isLoading = false,
  data = { all: 0, belumDikirim: 0, sudahDikirim: 0, belumDinilai: 0 },
  onChange = () => {},
  className,
  hideSearch = false,
  hideBelumDinilai = false,
}) => {
  const [activeFilter, setCurrentActiveFilter] = useState<FilterItem[]>(['ALL'])
  const [activeSearch, setCurrentActiveSearch] = useState<string>('')
  const [preSearchText, setPreSearchText] = useState<string>('')

  useEffect(() => {
    onChange?.({ filter: activeFilter, search: activeSearch })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFilter, activeSearch])

  return (
    <div className={clsx('flex items-center justify-between gap-4', className)}>
      <FilterStatusPengiriman
        hideBelumDinilai={hideBelumDinilai}
        isLoading={isLoading}
        counts={data}
        activeFilter={activeFilter}
        onChange={(selected) => {
          setCurrentActiveFilter(selected)
        }}
      />
      <div>
        {!hideSearch && (
          <SearchStatusPengiriman
            isLoading={isLoading}
            preSearchText={preSearchText}
            onChange={(event) => {
              const stripText = event.target.value.replace(/[^a-z0-9 ]/gi, '')
              setPreSearchText(stripText)
            }}
            onKeyDown={(event) => {
              if (event.key == 'Enter') {
                setCurrentActiveSearch(preSearchText)
              }
            }}
          />
        )}
      </div>
    </div>
  )
}
